import ClientPanelDesignContainer from './clientPanelDesing/ClientPanelDesign.container';

const ClientPanelDesign = () => <ClientPanelDesignContainer />;
export default ClientPanelDesign;
